import { useState, useEffect } from "react";
import { X, Cookie } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const COOKIE_KEY = "frontspace_cookies_accepted";

const TEXTS = {
  en: { msg: "We use cookies to improve your experience. By continuing to use this site, you agree to our", link: "Cookie Policy", accept: "Accept", decline: "Decline" },
  al: { msg: "Perdorim cookies per te permiresuar eksperiencen tuaj. Duke vazhduar te perdorni kete faqe, ju pranoni", link: "Politiken e Cookies", accept: "Pranoj", decline: "Refuzoj" },
  it: { msg: "Utilizziamo i cookie per migliorare la tua esperienza. Continuando a utilizzare questo sito, accetti la nostra", link: "Politica dei Cookie", accept: "Accetta", decline: "Rifiuta" },
  es: { msg: "Utilizamos cookies para mejorar tu experiencia. Al continuar usando este sitio, aceptas nuestra", link: "Politica de Cookies", accept: "Aceptar", decline: "Rechazar" },
};

export default function CookieConsent() {
  const { language } = useLanguage();
  const [show, setShow] = useState(false);
  const txt = TEXTS[language] || TEXTS.en;

  useEffect(() => {
    const accepted = localStorage.getItem(COOKIE_KEY);
    if (!accepted) setShow(true);
  }, []);

  const handleAccept = () => { localStorage.setItem(COOKIE_KEY, "true"); setShow(false); };
  const handleDecline = () => { localStorage.setItem(COOKIE_KEY, "false"); setShow(false); };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[55] p-4 sm:p-6" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto glass-card px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4 border border-[#00F0FF]/20">
        <Cookie size={20} className="text-[#00F0FF] shrink-0 mt-1 sm:mt-0" />
        <p className="text-slate-300 text-sm flex-1">
          {txt.msg}{" "}
          <a href="/cookies" className="text-[#00F0FF] hover:underline">{txt.link}</a>.
        </p>
        <div className="flex gap-3 shrink-0">
          <button onClick={handleDecline} className="text-slate-400 hover:text-white text-sm px-4 py-2 transition-colors" data-testid="cookie-decline">
            {txt.decline}
          </button>
          <button onClick={handleAccept} className="cyber-btn-primary text-xs px-5 py-2" data-testid="cookie-accept">
            {txt.accept}
          </button>
        </div>
        <button onClick={handleDecline} className="absolute top-2 right-2 sm:hidden text-slate-500">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
